export function using(resource, func) {
  try {
    func(resource);
  } finally {
    resource.dispose();
  }
}
